import React, { useState, useRef, useCallback } from 'react';
import ReactMapGL, { Marker, NavigationControl } from 'react-map-gl/mapbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFootballBall as footballIcon } from '@fortawesome/free-solid-svg-icons';
import mapboxgl from 'mapbox-gl';

import { MAPBOX_API_KEY } from '../../helpers/constants.js';

import 'mapbox-gl/dist/mapbox-gl.css';

function Map(props) {
  const [viewport, setViewport] = useState({
    latitude: 42.669269,
    longitude: -88.050844,
    zoom: 16,
    ...props.draftLocation,
  });
  const mapRef = useRef(null);
  const handleMove = useCallback((event) => setViewport(event.viewState), []);

  return (
    <div style={{ width: '100%', height: 'calc(100vh / 2)' }}>
      <ReactMapGL
        ref={mapRef}
        {...viewport}
        style={{ width: '100%', height: '100%' }}
        onMove={handleMove}
        mapboxAccessToken={MAPBOX_API_KEY}
        mapLib={mapboxgl}
        mapStyle="mapbox://styles/mapbox/streets-v9"
      >
        <Marker {...props.draftLocation} offset={[5, -15]}>
          <div className="text-green text-shadow-light">
            <FontAwesomeIcon icon={footballIcon} className="text-shadow-light mr-1" />
            <span className="text-bold text-italic text-background-yellow-light p-1">Heart Failure FFL Draft</span></div>
        </Marker>
        <div style={{ position: 'absolute', right: 0 }}>
          <NavigationControl />
        </div>
      </ReactMapGL>
    </div>
  );
}

export default Map;
